import { Button, styled } from '@mui/material';
import { commonBorderLight } from 'themes';
import { blue } from 'themes/colors';

export const StyledActionButton = styled(Button)<{ buttonColor?: 'blue' | 'white' | 'secondary-light' }>`
  min-width: 0;
  padding: 6px;
  width: ${({ size }) => size === 'large' && '40px'};
  height: ${({ size }) => size === 'large' && '40px'};
  background-color: ${({ buttonColor: color }) => (color === 'white' ? '#fff' : color === 'secondary-light' ? blue[50] : blue[400])};
  ${({ buttonColor: color }) => (color === 'white' ? `border: ${commonBorderLight};` : '')}
  &:hover {
    background-color: ${({ buttonColor: color }) => (color === 'white' ? '#fff' : color === 'secondary-light' ? blue[50] : 'rgb(14, 65, 112)')};
  }
  border-radius: 4px;
`;
